import React, { useEffect } from "react";


export default function GlivePage() {
  // Add className to body for page-specific styling
  useEffect(() => {
    document.body.className = 'glive-page';
    return () => {
      document.body.className = '';
    };
  }, []);

  return (
    <div id="root">
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          inset: 16,
          pointerEvents: "none",
        }}
      />
      <div className="wrapper">
        <div className="about-us-container">
          <div className="container">
            <div className="w-full h-screen flex items-center justify-center" style={{ textAlign: 'center', margin: '5rem' }}>
              <h1 className="text-3xl font-bold"> Hello G Live</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}